import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import { $i18N, $link, $info } from "@/utility/util.js";
import markdown, { parseUrl } from "@/utility/markdown/index.js";

// vue config

// css
import "ant-design-vue/dist/antd.css";
import "./styles/base.css";

const app = createApp(App);
app.use(store).use(router).use(Antd).mount("#app");

app.config.globalProperties.$filters = {
  i18n(key, ...params) {
    return $i18N(key, ...params);
  },
  link(value) {
    return $link(value);
  },
  info(value) {
    return $info(value);
  },
  markdown(value) {
    // if (window.$vezham && window.$vezham._INIT) {
    //   return window.$vezham.toMarkdown(value);
    // }
    return markdown.applyMarkdown(value);
  },
  parseUrl(value) {
    return parseUrl(value);
  },
};
